import React from 'react'
import '../styles/App.css'
import Auth from '../components/auth/Auth'

function AuthPage() {
  return (
    <div>
      <Auth />
    </div>
  )
}

export default AuthPage
